const mockData = [
  {
    id: 1,
    projectId: 1,
    projectType: 0,
    saveOption: 0,
    parentId: 1,
    subject: "Hello Guys.",
    sendTo:
      "abhishek@innologic.in, abhis@gmail.com, maaz.ahmad@innologic.in, ZUNAID.AHMAD@INNOLOGIC.IN, Chandan.kumar.silence@gmail.com",
    sendBcc: "abhishek@innologic.in, maaz.ahmad@innologic.in",
    sendCc: "NIKITA.RANA@INNOLOGIC.IN, NAVREEN.KAUR@INNOLOGIC.IN",
    requestType: 2,
    requestCount: 1,
    status: 1,
    active: 1,
    alarms: [
      {
        alarmTo:
          "chandan@gmail.com, abhis@gmail.com, maaz.ahmad@innologic.in, NIKITA.RANA@INNOLOGIC.IN, ZUNAID.AHMAD@INNOLOGIC.IN, chandan.kumar@innologic.in",
        alarmTime: "10:00 AM",
        alarmDate: "2024-12-23",
        alarmType: 0,
        alarmMessage: null,
      },
    ],
    files: [
      {
        fileName: "Bug 2- All checkbox not marked (1) (1).png",
        fileUrl: "1_1734323612391_Bug 2- All checkbox not marked (1) (1).png",
        fileSize: 250,
      },
    ],
    roles: [2, 1],
    users: [1, 55],
  },
  {
    id: 2,
    projectId: 1,
    projectType: 0,
    saveOption: 0,
    parentId: 2,
    subject: "Hello Guys.",
    sendTo:
      "abhishek@innologic.in, abhis@gmail.com, maaz.ahmad@innologic.in, ZUNAID.AHMAD@INNOLOGIC.IN, Chandan.kumar.silence@gmail.com",
    sendBcc: "abhishek@innologic.in, maaz.ahmad@innologic.in",
    sendCc: "NIKITA.RANA@INNOLOGIC.IN, NAVREEN.KAUR@INNOLOGIC.IN",
    requestType: 1,
    requestCount: 1,
    status: 1,
    active: 1,
    alarms: [],
    files: [],
    roles: [],
    users: [],
  },
];

export default mockData;
